<template>
  <div class="py-3 bg-finger">
    <div class="container">
      <div class="mb-3"><img src="\img\logopriadi.png" class="img-fluid d-block" width="140" alt="PRiADI logo" /></div>
      <p class="lead text-white fw-bold" style="font-size: var(--text-base)">
        {{ $t('sloganHomeSubtitle') }}
      </p>
    </div>
    <div class="container-fluid">
      <div class="d-flex align-items-center overflow-scroll hide-scrollbar">
        <img v-for="i in 6" v-bind:key="i" v-bind:src="`/img/slide-home/${i}.png`" class="w-75 me-2" alt="Promotional banner" />
      </div>
    </div>
  </div>

  <div class="container mt-4 mb-5 pb-3">
    <ul class="nav nav-pills mb-3 gap-1" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active rounded-pill fw-bold"
          id="pills-home-tab"
          data-bs-toggle="pill"
          data-bs-target="#pills-home"
          type="button"
          role="tab"
          aria-controls="pills-home"
          aria-selected="true">
          {{ $t('testPackage') }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link rounded-pill fw-bold"
          id="pills-profile-tab"
          data-bs-toggle="pill"
          data-bs-target="#pills-profile"
          type="button"
          role="tab"
          aria-controls="pills-profile"
          aria-selected="false">
          {{ $t('promo') }}
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div class="col mb-3" v-for="(subcategory, index) in get_subcategory" v-bind:key="subcategory">
          <div class="card shadow package-card p-0" @click="openDetail(index)">
            <div class="card-body text">
              <span class="text-primary d-block fw-bold fs-5">{{ subcategory.name }}</span>
              <span class="d-block text-muted" style="font-size: var(--text-xs); font-weight: var(--font-medium)">
                {{ subcategory.grouping }}
              </span>
              <div class="d-flex justify-content-between align-items-end mt-4">
                <span class="fw-bold fs-6 d-block">
                  {{ 'Rp.' + Intl.NumberFormat('id').format(subcategory.price) + ',-' }} <br />
                  <span class="fw-normal" v-if="subcategory.is_consultation === '1'">+ {{ $t('freeConsult') }}</span>
                </span>
                <div class="text-primary fw-bold bg-primary text-white px-3 py-1 rounded-3 rounded click-effect">
                  {{ $t('selectPackage') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="row row-cols-1 gap-2 mb-3" v-if="get_promo">
          <div class="col" v-for="(promo, index) in get_promo" v-bind:key="promo">
            <div class="card shadow package-card" @click="openDetail(index, 'yes')">
              <div class="card-body text">
                <span class="text-primary d-block fw-bold fs-5">{{ promo.name }}</span>
                <span class="d-block text-muted" style="font-size: var(--text-xs); font-weight: var(--font-medium)">
                  {{ promo.grouping }}
                </span>
                <div class="d-flex justify-content-between align-items-end mt-3">
                  <div>
                    <span class="fw-bold me-1 d-block">
                      <s class="fw-bold text-danger d-block">{{ 'Rp.' + Intl.NumberFormat('id').format(promo.price_real) }}</s>
                      {{ 'Rp.' + Intl.NumberFormat('id').format(promo.price) }}
                    </span>
                    <span class="fw-normal" v-if="promo.is_consultation === '1'">+ {{ $t('freeConsult') }}</span>
                  </div>
                  <div class="text-primary fw-bold bg-primary text-white px-3 py-1 rounded-3 rounded click-effect">
                    {{ $t('selectPackage') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow-lg mb-3" style="border-radius: var(--radius-lg)">
          <div class="card-body">
            <p class="h5">{{ $t('promo') }}</p>
            <p style="font-size: var(--text-sm); text-align: justify">
              {{ $t('voucherCodeText') }}
            </p>
            
            <!-- Error message -->
            <div v-if="promoError" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{ promoError }}
              <button type="button" class="btn-close" @click="promoError = ''" aria-label="Dismiss"></button>
            </div>
            
            <!-- Success message -->
            <div v-if="promoSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{ promoSuccess }}
              <button type="button" class="btn-close" @click="promoSuccess = ''" aria-label="Dismiss"></button>
            </div>
            
            <form @submit.prevent="select_promo(referral_code)">
              <input
                type="text"
                v-model="referral_code"
                class="form-control w-100 mx-auto"
                :placeholder="$t('voucherCodeHint')"
                aria-label="Voucher code" />
              <button type="submit" class="btn text-white d-block w-100 mt-2 fs-6" style="background-color: var(--color-primary)">
                {{ $t('submit') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <BottomNav />

  <!-- Modal for login options (shown when user is not authenticated) -->
  <div class="modal fade" :class="{ show: showLoginModal }" :style="{ display: showLoginModal ? 'block' : 'none' }" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <p class="text-muted mb-4">{{ $t('guessModalText') }}</p>
          <div class="d-grid gap-2">
            <button class="btn btn-primary" @click="handleSignIn">
              <i class="bi bi-box-arrow-in-right"></i> {{ $t('signin') }}
            </button>
            <button class="btn btn-outline-secondary" @click="handleGuestAccess">
              <i class="bi bi-person-check"></i> {{ $t('continueAsGuest') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" :class="{ show: showLoginModal }" :style="{ display: showLoginModal ? 'block' : 'none' }"></div>
</template>

<script>
import BottomNav from '../components/BottomNav'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    BottomNav,
    // Navigation,
  },
  data() {
    return {
      selectedPills: false,
      referral_code: '',
      get_subcategory: [],
      get_promo: [],
      showLoginModal: false,
      promoError: '',
      promoSuccess: '',
    }
  },
  created() {
    this.select_subcategory()
  },
  methods: {
    select_subcategory() {
      let self = this
      axios
        .get('https://api.priadi.id/api/list_report', {
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          self.get_subcategory = response.data.list_report.sort((a, b) => a.price - b.price)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    select_promo(referral_code) {
      let self = this
      
      // Clear previous messages
      self.promoError = ''
      self.promoSuccess = ''
      
      // Check if referral code is empty
      if (!referral_code || referral_code.trim() === '') {
        self.promoError = self.$t('invalidReferralCode')
        return
      }
      
      axios
        .get('https://api.priadi.id/api/list_report', {
          params: { reff_code: referral_code },
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          const promoData = response.data.list_report.sort((a, b) => a.price - b.price)
          
          // Check if the referral code provides any discount
          // by comparing if prices have changed
          let hasDiscount = false
          
          if (promoData && promoData.length > 0) {
            // Compare the first item's price to see if there's a discount
            for (let i = 0; i < promoData.length; i++) {
              if (promoData[i].price < promoData[i].price_real) {
                hasDiscount = true
                break
              }
            }
          }
          
          if (!hasDiscount) {
            // Referral code is invalid - no discount applied
            self.promoError = self.$t('referralCodeError')
            self.get_promo = ''
            self.referral_code = ''
          } else {
            // Referral code is valid - show success message
            self.get_promo = promoData
            self.promoSuccess = self.$t('codeApplied')
            self.referral_code = ''
          }
        })
        .catch((error) => {
          console.log(error)
          self.promoError = self.$t('codeInvalid')
          self.get_promo = ''
          self.referral_code = ''
        })
    },
    openDetail(index, isPromo = 'no') {
      if (isPromo === 'no') {
        const item = this.get_subcategory[index]
        if (!item) return
        this.$store.dispatch('setPackage', item)
        this.$router.push({ name: 'Package Detail' })
      } else {
        const item = this.get_promo[index]
        if (!item) return
        item.voucher_code = this.referral_code
        this.$store.dispatch('setPackage', item)
        this.$router.push({ name: 'Package Detail' })
      }
    },
    closeLoginModal() {
      this.showLoginModal = false
    },
    handleSignIn() {
      this.closeLoginModal()
      this.$router.push('/auth')
    },
    handleRegister() {
      this.closeLoginModal()
      this.$router.push('/register')
    },
    handleGuestAccess() {
      this.closeLoginModal()
    },
  },
  mounted() {
    document.body.classList.add('body-tinted')
    this.package = this.$store.getters.getPackage
    
    // Show login modal if user is not authenticated
    if (!this.$store.getters.isAuth) {
      this.showLoginModal = true
    }
  },
  unmounted() {
    document.body.classList.remove('body-tinted')
  },
}
</script>

<style scoped>
.padding-tab-content {
  padding-top: 1em;
}
</style>
